import dataEngineerImg from "../assets/img/teams/roles-de.svg";
import pmImg from "../assets/img/teams/Product-management.svg";
import beImg from "../assets/img/teams/roles-be.svg";
import feImg from "../assets/img/teams/roles-fe.svg";
import qaImg from "../assets/img/teams/QA-engineering.svg";
import mobileImg from "../assets/img/teams/Mobile-engineering.svg";
import devOpsImg from "../assets/img/teams/roles-dev-ops.svg";
import siteImg from "../assets/img/teams/roles-site-reliability.svg";
import cyberImg from "../assets/img/teams/roles-cyber-security.svg";

const roles = [
  {
    title: "Backend Engineer",
    image: beImg,
  },
  {
    title: "Data Engineer",
    image: dataEngineerImg,
  },
  {
    title: "Product Manager",
    image: pmImg,
  },
  {
    title: "Cyber Security Engineer",
    image: cyberImg,
  },
  {
    title: "QA Engineering",
    image: qaImg,
  },
  {
    title: "Frontend Engineer",
    image: feImg,
  },
  {
    title: "Mobile Engineer",
    image: mobileImg,
  },
  {
    title: "DevOps Cloud Engineer",
    image: devOpsImg,
  },
  {
    title: "Site reliability Engineer",
    image: siteImg,
  },
];
export default roles;
